import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import api from "../api";
import { useGlobal } from "../GlobalContext";

function EmailVerification({ app }) {
  const [params] = useSearchParams();
  const [isVerifying, setIsVerifying] = useState(true);
  const [isVerified, setIsVerified] = useState(false);

  const { hl } = useGlobal();

  useEffect(() => {
    async function verify() {
      setIsVerifying(true);
      const address = params.get("address");
      const key = params.get("key")

      if(address === null || key === null) {
        setIsVerified(false);
      }
      else {
        try {
          const res = await api.POST(`/auth/verification/email?address=${address}&key=${key}`);
          setIsVerified(true);
        }
        catch(e) {
          setIsVerified(false);
        }
      }

      setIsVerifying(false);
    };

    verify();
  }, []);

  if(isVerifying) {
    return (
      <div>
        {hl === "ko" ? "인증 중..." : "Verifying..."}
      </div>
    );
  }

  if(isVerified) {
    return (
      <div>
        {hl === "ko" ? "인증 성공! 사용 중이던 서비스(앱/웹)로 돌아가주세요.": "Verification successful! Please return to the app/web you were using."}
      </div>
    );
  }

  return (
    <div>
      {hl === "ko" ? "인증 실패": "Verification failed"}
    </div>
  );
}

function EmailVerificationContainer() {
  const { app } = useParams();
  
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
      <EmailVerification app={app}/>
    </div>
  );
}

export default EmailVerificationContainer;